var React = require('react');

function PillsTop (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"34","width":"14","height":"242","rx":"7","transform":"rotate(-90 0 34)","fill":"#7200A0","key":0}),React.createElement("rect",{"x":"44","y":"14","width":"14","height":"140","rx":"7","transform":"rotate(-90 44 14)","fill":"#FF5670","key":1}),React.createElement("rect",{"x":"114","y":"55","width":"14","height":"90","rx":"7","transform":"rotate(-90 114 55)","fill":"#FF5670","key":2})]);
}

PillsTop.defaultProps = {"width":"242","height":"55","viewBox":"0 0 242 55","fill":"none"};

module.exports = PillsTop;

PillsTop.default = PillsTop;
